var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "fill",
    d: "M1.70001 12C1.74801 8.41915 2.36961 5.45515 4.18881 3.68875C5.95521 1.86955 8.91921 1.24795 12.5 1.19995C16.0808 1.24795 19.0448 1.86955 20.8112 3.68875C22.6304 5.45515 23.252 8.41915 23.3 12C23.252 15.5808 22.6304 18.5448 20.8112 20.3112C19.0448 22.1304 16.0808 22.752 12.5 22.8C8.91921 22.752 5.95521 22.1304 4.18881 20.3112C2.36961 18.5448 1.74801 15.5808 1.70001 12Z",
    fill: "#ABAEB2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.8648 12.9815H14.48C15.3656 12.3455 15.8888 11.3207 15.8888 10.2311C15.8888 8.36148 14.3672 6.84229 12.5 6.84229C10.6328 6.84229 9.11122 8.36388 9.11122 10.2311C9.11122 11.3207 9.63682 12.3455 10.52 12.9815H9.13522C8.19922 12.9815 7.43842 13.7423 7.43842 14.6783V15.4631C7.43842 16.3991 8.19922 17.1599 9.13522 17.1599H15.8648C16.8008 17.1599 17.5616 16.3991 17.5616 15.4631V14.6783C17.5592 13.7399 16.8008 12.9815 15.8648 12.9815ZM12.4568 8.44069C11.4704 8.44309 10.6688 9.24229 10.6688 10.2287C10.6688 10.4039 10.5272 10.5455 10.352 10.5455C10.1768 10.5455 10.0352 10.4039 10.0352 10.2287C10.0376 8.89188 11.12 7.80949 12.4568 7.80709C12.632 7.80709 12.7736 7.94868 12.7736 8.12388C12.7736 8.29908 12.632 8.44069 12.4568 8.44069Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMy);
export default __webpack_public_path__ + "static/media/my.b127723d6131b40abe64d759a5c49dbb.svg";
export { ForwardRef as ReactComponent };